function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "ICON_GREY_PLAY_svg__cls-1",
  d: "M7.26 36.14V13.89c0-1.72 1.24-2.48 2.77-1.69L32.3 23.63c1.52.78 1.52 2.06 0 2.84L10 37.84a2.49 2.49 0 01-1.14.3c-.93 0-1.6-.74-1.6-2zM0 2v46a1.76 1.76 0 002.77 1.7l45.45-23.21c1.53-.78 1.53-2.06 0-2.84L2.77.31A2.55 2.55 0 001.62 0C.67 0 0 .74 0 2z"
});

function SvgIconGreyPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 49.37 50"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OS4zNyA1MCI+PGRlZnM+PC9kZWZzPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTcuMjYsMzYuMTRWMTMuODljMC0xLjcyLDEuMjQtMi40OCwyLjc3LTEuNjlMMzIuMywyMy42M2MxLjUyLjc4LDEuNTIsMi4wNiwwLDIuODRMMTAsMzcuODRhMi40OSwyLjQ5LDAsMCwxLTEuMTQuM0M3LjkzLDM4LjE0LDcuMjYsMzcuNCw3LjI2LDM2LjE0Wk0wLDJWNDhhMS43NiwxLjc2LDAsMCwwLDIuNzcsMS43TDQ4LjIyLDI2LjQ5YzEuNTMtLjc4LDEuNTMtMi4wNiwwLTIuODRMMi43Ny4zMUEyLjU1LDIuNTUsMCwwLDAsMS42MiwwQy42NywwLDAsLjc0LDAsMloiLz48L3N2Zz4=";
export { SvgIconGreyPlay as ReactComponent };